module.exports = __webpack_public_path__ + "img/62.8167a715.png";